export default "__VITE_PUBLIC_ASSET__6a81a625__"